<template>
  <div class=" relative flex items-center">
    <button
      class=" relative p-1 border-2 border-transparent text-white rounded-full
       focus:outline-none  transition duration-150 ease-in-out"
      aria-label="Notifications"
      @click.prevent="showNotifications = !showNotifications"
    >
      <svg
        class="h-6 w-6 lg:h-8 lg:w-8"
        :class="{ 'text-white': hasNotifications }"
        stroke="currentColor"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        />
      </svg>
      <div
        class="absolute top-0 right-0 block h-4 w-4 rounded-full text-white shadow-solid bg-pink flex justify-center items-center
              font-semibold p-3 font-mono -mr-1 -mt-1 hover:bg-red"
        v-if="notifications.length > 0"
      >
        {{ notifications.length }}
      </div>
    </button>
    <div>
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 scale-90"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-90"
      >
        <div
          class=" bg-white shadow-lg border-2 border-white rounded-lg pointer-events-auto absolute right-0 w-screen max-w-sm mt-6"
          style="z-index: 100"
          v-show="showNotifications"
        >
          <div class="rounded-lg shadow-xs overflow-hidden">
            <div
              class="p-4 text-gray-400 text-xl text-center"
              v-if="!hasNotifications"
            >
              No notifications
            </div>
            <div
              class="p-4"
              v-for="(notification, idx) in notifications"
              :key="idx"
            >
              <div v-if="notification.type === 'COMMENT_ADDED'">
                <comment-added-notification
                  :notification="notification"
                  v-on:dismiss-notification="dismissNotification"
                ></comment-added-notification>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { notificationCollection, auth } from "../utils/firebase";
import CommentAddedNotification from "./CommentAddedNotification";
import { mapGetters } from "vuex";

export default {
  name: "NotificationMenu",
  components: { CommentAddedNotification },
  data() {
    return {
      showNotifications: false,
      notifications: [],
      notificationSubscription: null
    };
  },
  watch: {
    loggedIn(newVal, oldval) {
      if (newVal) {
        this.createNotificationSubscription();
      }
    }
  },
  methods: {
    hideNotificationMenu(e) {
      if (!this.$el.contains(e.target)) {
        this.showNotifications = false;
      }
    },
    dismissNotification(notificationID) {
      notificationCollection
        .doc(notificationID)
        .delete()
        .then(() => {
          if (this.notifications.empty) {
            this.showNotifications = false;
          }
        });
    },
    createNotificationSubscription() {
      this.notificationSubscription = notificationCollection
        .where("user", "==", auth.currentUser.uid)
        .onSnapshot(querySnapshot => {
          this.notifications = [];
          querySnapshot.forEach(doc => {
            this.notifications.push({ id: doc.id, ...doc.data() });
          });
        });
    }
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    hasNotifications() {
      return this.notifications.length > 0;
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.createNotificationSubscription();
    }
    document.addEventListener("click", this.hideNotificationMenu);
  },
  updated() {
    if (this.loggedIn && this.notificationSubscription == null) {
      this.createNotificationSubscription();
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hideNotificationMenu);
    if (this.notificationSubscription) {
      this.notificationSubscription();
    }
  }
};
</script>

<style scoped></style>
